import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, MenuController } from 'ionic-angular';
import { LoginService } from '../../services/login.service';
import { HomePage } from '../home/home';
import { RecuperarContraseñaPage } from '../recuperar-contraseña/recuperar-contraseña';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import { ServiciosSharedService } from '../../services/servicios-shared.service';
/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  email: string;
  password: string
  public invalidAccount = false;
  public loginForm: FormGroup;
  constructor(private navCtrl: NavController, private navParams: NavParams, private auth: AuthService,
    private toastController: ToastController, private menuCtrl: MenuController, private servicioShared: ServiciosSharedService) {
    this.InitForm();
    this.menuCtrl.enable(false, 'myMenu');

  }

  ionViewCanEnter() {
    if (this.auth.isLoggedIn()) {
      this.navCtrl.setRoot(HomePage)
    }
  }

  login() {

    let email = this.loginForm.value['email'];
    let password = this.loginForm.value['password'];
    this.invalidAccount = false;
    this.auth.login(email, password)
      .subscribe(res => {
        console.log("RESPUESTA LOGIN ", res)
        if (!res.user) {
          this.servicioShared.mostrarMensajeError("Las credenciales ingresadas son incorrectas");
          return;
        }
        this.servicioShared.mostrarMensaje("Login Correcto ")
        console.log("RESPUESTA LOGIN ", res)
        this.navCtrl.setRoot(HomePage)
      }, errorRes => {
        console.log("ERROR ", errorRes)
        this.servicioShared.mostrarMensajeError(errorRes.error.error.message);
        console.log(errorRes.error.error.message);

        if (errorRes.error.error.code == "LOGIN_FAILED") {
          this.invalidAccount = true;
        }

      })
  }

  InitForm() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email, Validators.minLength(4)]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    })
  }


  //MUESTRA MENSAJE
  // presentToast(msg) {
  //   let toast = this.toastController.create({
  //     message: msg,
  //     duration: 3000,
  //     position: 'center'
  //   });

  //   toast.onDidDismiss(() => {
  //     console.log('Dismissed toast');
  //   });

  //   toast.present();
  // }

  public GoToPasswordRecover($event) {
    this.navCtrl.push(RecuperarContraseñaPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts